import { logger } from '@driftt/traffic-control'

export const { logError } = logger
